export const getRootDomainRegExp = (domains: string[]) => {
    let preparedDomainsArr = domains.map(domain => {
        let name = `\\.${domain}`; 
        return name;
    });
    return preparedDomainsArr.join('|');
}